module.exports = __webpack_public_path__ + "img/glassquality_3.3ebc4ed3.png";